<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title">Frequently Asked Questions</h1>
      <h2 class="subtitle">Here are some questions that have already been asked by your classmates</h2>
      <div v-for="(category, i) of FAQs" class="columns is-centered" :key="i">
        <div class="column is-12">
          <h3 class="subtitle is-size-4 has-text-left">
            <span class="icon">
              <font-awesome-icon class="arrowIndicator" :icon="activeIcon(category.title)"/>
            </span>
            {{category.title}}:
          </h3>
          <div v-for="(FAQ, j) of category.content" :key="j" class="columns">
            <askedQuestion class="column" :QnA="FAQ"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { FAQClient } from "@/clients/FAQClient.js";
import askedQuestion from "@/components/faq/AskedQuestion.vue";
import { log } from "util";
export default {
  name: "FAQ",
  components: { askedQuestion },
  data: function() {
    return {
      activeCategories: [],
      FAQs: [
        // {
        //   title: "Mentor",
        //   id: 0,
        //   content: [
        //     {
        //       question:
        //         "How much wood could a woodchuck chuck If a woodchuck could chuck wood?",
        //       answer:
        //         "As much wood as a woodchuck could chuck, If a woodchuck could chuck wood."
        //     },
        //     {
        //       question:
        //         "How much wood could a woodchuck chuck If a woodchuck could chuck wood?",
        //       answer:
        //         "As much wood as a woodchuck could chuck, If a woodchuck could chuck wood."
        //     },
        //     {
        //       question:
        //         "How much wood could a woodchuck chuck If a woodchuck could chuck wood?",
        //       answer:
        //         "As much wood as a woodchuck could chuck, If a woodchuck could chuck wood."
        //     }
        //   ]
        // },
        // {
        //   title: "Technical",
        //   id: 1,
        //   content: [
        //     {
        //       question:
        //         "How much wood could a woodchuck chuck If a woodchuck could chuck wood?",
        //       answer:
        //         "As much wood as a woodchuck could chuck, If a woodchuck could chuck wood."
        //     },
        //     {
        //       question:
        //         "How much wood could a woodchuck chuck If a woodchuck could chuck wood?",
        //       answer:
        //         "As much wood as a woodchuck could chuck, If a woodchuck could chuck wood."
        //     },
        //     {
        //       question:
        //         "How much wood could a woodchuck chuck If a woodchuck could chuck wood?",
        //       answer:
        //         "As much wood as a woodchuck could chuck, If a woodchuck could chuck wood."
        //     }
        //   ]
        // }
      ]
    };
  },
  methods: {
    processFaqs(data) {
      let processingFaq = {
        title: data.faqGroup.title,
        id: data.faqGroup.id,
        content: []
      };
      for (const faq of data.faqs) {
        let single = {
          question: faq.question,
          answer: faq.answer
        };
        processingFaq.content.push(single);
      }
      this.FAQs.push(processingFaq);
    },
    getFaqs(Id) {
      FAQClient.getFAQ(Id)
        .then(response => {
          console.log(response);

          this.processFaqs(response.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    activeIcon(title) {
      if (this.activeCategories.includes(title)) {
        return "angle-down";
      } else {
        return "angle-right";
      }
    },
    toggleActiveCategory(title) {
      if (this.activeCategories.includes(title)) {
        this.activeCategories.splice(this.activeCategories.indexOf(title));
      } else {
        this.activeCategories.push(title);
      }
    }
  },
  mounted() {
    this.getFaqs(1);
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";
</style>

